export default "__VITE_ASSET__gE5LWCtW__"